import React from "react";
import { IonRow, IonCol, IonIcon, IonLabel } from "@ionic/react";
import { removeOutline, addOutline } from "ionicons/icons";

import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { Product } from "@core/types";
import { useCartData } from "../../../../../providers/cartDataStore";
import { calculateDiscount } from "../../../../../utils/calculateDiscount";
import { useProductCardActions } from "../../../../../providers/useProductActions";

interface QuantityCounterProps {
  product: Product;
}
const cx = classNames.bind(styles);

const QuantityCounter = ({ product }: QuantityCounterProps) => {
  const { cartProductsMap } = useCartData();

  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;
  const { addToCart, removeProductFromCart } = useProductCardActions();

  const discount = calculateDiscount(
    product.type,
    product.onSale,
    product.price,
    product.regularPrice,
    product.priceHtml
  );

  const isDisabledToAdd =
    !product?.purchasable ||
    (product.stockStatus === "instock" && cartQuantity === product.stockQuantity) ||
    product.stockQuantity < 1;

  return (
    <IonRow
      className={cx("quantityCounter", "border-1 border-solid !bg-transparent flex justify-between items-center")}
      onClick={(e) => e.stopPropagation()}
    >
      <IonCol size="3" className="ion-text-center ion-no-padding" onClick={() => removeProductFromCart(product.id)}>
        {product.stockStatus === "instock" && (
          <IonIcon
            icon={removeOutline}
            className={cx(styles.icon, styles.removeQuantity, "!bg-transparent !text-primary")}
          />
        )}
      </IonCol>
      <IonCol size="6" className={cx("quantityValue", "flex flex-col items-center")}>
        <IonLabel className={cx("text-[11px] font-semibold text-black", discount && "text-red-500")}>
          {parseFloat(product.price) * cartQuantity}р.
        </IonLabel>
        <IonLabel className="font-medium text-[10px] text-black">{cartQuantity} шт.</IonLabel>
      </IonCol>
      <IonCol
        size="3"
        onClick={() => {
          addToCart(product);
        }}
        className={cx("ion-text-center ion-no-padding", {
          disabled: isDisabledToAdd,
        })}
      >
        <IonIcon icon={addOutline} className={cx(styles.icon, styles.addQuantity, "!bg-transparent !text-primary")} />
      </IonCol>
    </IonRow>
  );
};

export default QuantityCounter;
